import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class DomesticSearchProxy extends ProxyBase {
  postDomesticSearch(params) {
    return this.post('search', params, {}, undefined, false, 'domesticSearch')
  }

  postDomesticSearchCount(params) {
    return this.post('count', params)
  }

  getDomesticSearchDetail(params) {
    return this.post('detail', params)
  }
}

export default new DomesticSearchProxy('DomesticSearch/')
